<div class="row gy-3 gx-3x">

  <div class="col-md-4 col-sm-12 col-xl-4">
    <div class="location-selector-container px-3">
      <div class="item">
        <fa-icon [icon]="icons.departure"></fa-icon>
      </div>
      <div class="item w-90">
        <div data-bs-toggle="dropdown" class="form-input w-100">
          <div class=" ">
            <app-airports-deropdown [formGrp]="searchForm" formCtrlName="flightFrom"></app-airports-deropdown>
          </div>
        </div>
        <ul class="dropdown-menu customer-dropdown p-0">

          <li *ngFor="let airport of airportFromAutoComplete" (click)="selectAirport(airport)"
            class="d-flex drop-item cur-pnt  align-items-center px-2 py-3">
            <fa-icon [icon]="icons.planeUp"></fa-icon>
            <h6 class="dropdown-text">{{ '('+ airport?.iata + ') ' + airport.airport}}</h6>

          </li>
        </ul>
      </div>
    </div>


  </div>
  <div class="col-md-4 col-sm-12 col-xl-4">
    <div class="location-selector-container px-3">
      <div class="item">
        <fa-icon [icon]="icons.arrival"></fa-icon>
      </div>
      <div class="item airport-display w-90">
        <div data-bs-toggle="dropdown" class="form-input w-100">
          <div class=" ">
            <app-airports-deropdown [placeholder]="'Going To?'" [formGrp]="searchForm"
              formCtrlName="flightTo"></app-airports-deropdown>
          </div>
        </div>
        <ul class="dropdown-menu customer-dropdown p-0">

          <li *ngFor="let airport of airportToAutoComplete" (click)="selectToAirport(airport)"
            class="d-flex drop-item cur-pnt  align-items-center px-2 py-3">
            <fa-icon [icon]="icons.planeUp"></fa-icon>
            <h6 class="dropdown-text">{{ '('+ airport?.iata + ') ' + airport.airport}}</h6>

          </li>
        </ul>
        <span class="err text-danger " *ngIf="showToTrigger">
          Departure airport cant be same as arrival airport
        </span>
      </div>

    </div>
  </div>
  <div class="col-md-4 col-sm-12">
    <div class="range-section px-3">
      <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.calendar"></fa-icon>
      <input class="date-picker-input" type="text" placeholder="Leaving & Return date" [minDate]="minDate"
        [bsConfig]="{ isAnimated: true, showWeekNumbers: false, rangeInputFormat: 'ddd, MMMM Do' }"
        [(ngModel)]="dateRange" #dp="bsDaterangepicker" bsDaterangepicker>
      <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.caretDown"></fa-icon>
    </div>
  </div>
  <div class="col-md-4 col-6 col-xl-4">
    <form class="guest-section" [formGroup]="form">
      <div class="d-flex flex-row align-items-center" data-bs-toggle="dropdown">
        <fa-icon class="pt-3 pt-md-0" [icon]="icons.users"></fa-icon>
        <input [formControlName]="'occupants'" class="guest-input" type="text" placeholder="Guests">
        <fa-icon class="pt-3 pt-md-0" [icon]="icons.caretDown"></fa-icon>
      </div>
      <ul class="dropdown-menu" (click)="$event.stopPropagation()">
        <div *ngFor="let occupant of occupant_types" class="d-flex justify-content-between align-items-center pb-3">
          <div class="d-flex align-items-center">
            <fa-icon class="dropdown-icon occupants-icon me-3" [icon]="occupant.icon"></fa-icon>
            <div>
              <h6 class="dropdown-text">{{occupant.name}}</h6>
              <small class="dropdown-subtext">{{occupant.subText}}</small>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <fa-icon (click)="decrement(occupant.name)" class="dropdown-icon dropdown-caret" [icon]="icons.caretDown">
            </fa-icon>
            <input [formControlName]="occupant.name" (keyup)="constructString()" class="dropdown-input" type="number"
              placeholder="0">
            <fa-icon (click)="increment(occupant.name)" class="dropdown-icon dropdown-caret" [icon]="icons.caretUp">
            </fa-icon>
          </div>
        </div>
      </ul>
    </form>
  </div>
  <div class="col-md-4 col-6 col-xl-4">
    <div class="cabin-section" [formGroup]="form">
      <select id="" class="cabin-input" formControlName="cabin">
        <!-- <option selected value="">Cabin</option> -->
        <option value="economy">Economy</option>
        <option value="premium">Premium Economy</option>
        <option value="business">Business</option>
        <option value="first">First Class</option>
      </select>
      <fa-icon [icon]="icons.caretDown"></fa-icon>
    </div>
  </div>
  <div class="col-md-4 col-sm-12 col-xl-4">
    <div class="search-button w-100 h-100">
      <app-button class="w-100 h-100" [className]="'w-100 h-100'"
        [disabled]="searchForm.invalid || form.invalid || !dateRange || (form.controls['adults'].value <1)"
        (onclick)="search()" warning>Search</app-button>
    </div>
  </div>
</div>
